<template>
  <AppToolbar>
    <div class="flex z-90" slot="left" :class="$style.leftBar" ref="leftBar">
      <AppTextField
        style="width: 160px"
        icon="train"
        type="number"
        min="1"
        maxlength="12"
        @enter="getTimeSchedule"
        v-model="tekniskttagnummer"
        placeholder="Tågnummer"
      />
      <AppSelectField
        placeholder="Tågplan"
        :options="plansList"
        v-model="activePlan"
        display-key="id_formatted"
      >
        <template v-slot="{ option, selected }">
          <AppListItem :active="selected">
            {{ option.id_formatted }}
            <template v-slot:secondary>
              {{ option.valid_from }} - {{ option.valid_until }}
            </template>
          </AppListItem>
        </template>
      </AppSelectField>
      <AppButton
        @click="getTimeSchedule"
        :class="$style.submitButton"
        :disabled="disabledSubmitButton"
        icon="arrow_forward"
        >Hämta</AppButton
      >
    </div>
    <div
      slot="right"
      class="flex pt-3 mr-4"
      v-if="
        $store.get('trainSchedule/allList').length &&
        !$store.get('trainSchedule/pending')
      "
    >
      <div class="rounded-full bg-gray-20 flex text-xs px-2 py-1">
        <div class="pr-2 border-r border-gray-30">
          {{ display.sokande }}
        </div>
        <div class="pl-2">
          {{ display.operator }}
        </div>
      </div>
    </div>
  </AppToolbar>
</template>

<script>
import { get } from 'vuex-pathify'
import { startOfMonth } from 'date-fns'

export default {
  name: 'TimetableToolbar',

  data() {
    return {
      tekniskttagnummer: '',
    }
  },

  computed: {
    plans: get('migratedPlan/all'),

    plansList: get('migratedPlan/allList'),

    activePlanId: get('migratedPlan/active'),

    display: get('trainSchedule/display'),

    activePlan: {
      get() {
        return this.plans[this.activePlanId]
      },

      set(value) {
        this.$store.set('migratedPlan/active', value ? value.id : null)
      },
    },

    disabledSubmitButton() {
      return (
        !this.tekniskttagnummer.length ||
        this.tekniskttagnummer === '0' ||
        !this.activePlanId
      )
    },
  },

  methods: {
    getTimeSchedule() {
      if (this.disabledSubmitButton) return
      const { tekniskttagnummer } = this
      const params = {
        tekniskttagnummer,
        planId: this.activePlan.sysid,
      }
      this.$store.dispatch('trainSchedule/fetch', params)
      this.$store.set(
        'timetable/dateStart',
        startOfMonth(this.activePlan.valid_from)
      )
      this.$store.set('timetable/dateEnd', this.activePlan.valid_until)
      this.$store.set('timetable/tekniskttagnummer', tekniskttagnummer)
    },
  },
}
</script>

<style lang="postcss" module>
.leftBar:focus-within {
  @apply bg-gray-10 shadow;
}

.leftBar .submitButton {
  transform: scaleX(0);
  transform-origin: left;
  @apply opacity-0 pointer-events-none timing-productive-standard duration-fast-1 transition-property;
}

.leftBar:focus-within .submitButton {
  transform: scaleX(1);
  @apply opacity-100 pointer-events-auto;
}
</style>
